<template>
  <v-layout align-center>
    <v-flex py-0 grow>
      <v-text-field
        v-model="giftcard.code"
        maxlength="6"
        :disabled="giftcard.loading || !!giftcard.amount"
        :error-messages="giftcard.errors.code"
        :label="$t('MENU.GIFT_CARD')"
        :loading="giftcard.loading"
      >
        <template v-if="giftcard.amount" v-slot:prepend-inner>
          <v-icon size="20" class="mr-2" color="green">fas fa-check</v-icon>
        </template>
        <template v-if="giftcard.amount" v-slot:append>{{ giftcard.amount }}</template>
      </v-text-field>
    </v-flex>
    <v-flex py-0 px-0 shrink v-if="giftcard.amount">
      <v-btn class="ma-0 mr-2" icon @click="clearInput">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import debounce from "@/utils/TinyDebounce";

export default {
  data() {
    return {
      giftcard: {
        code: null,
        errors: {},
        loading: false,
        amount: null
      }
    };
  },

  watch: {
    "giftcard.code": debounce(function(val) {
      this.onCodeChange(val);
    }, 500)
  },

  methods: {
    resetInput() {
      this.giftcard = {
        code: null,
        errors: {},
        loading: false,
        amount: null
      };
    },

    clearInput() {
      console.log("clear input");
      this.resetInput();
      this.$emit("onGiftCodeSuccess", null);
    },

    async onCodeChange(e) {
      if (e && e.length === 6) {
        this.giftcard.loading = true;

        // reset giftcard related data
        this.giftcard.errors = {};
        this.giftcard.amount = null;

        try {
          const res = await this.$axios.get(`/cart/gift-card?code=${e}`);
          this.giftcard.amount = res.data.data.amount;
          this.$emit("onGiftCodeSuccess", this.giftcard.code);
        } catch (error) {
          if (error.status === 422 && error.data) {
            this.giftcard.errors = error.data.errors;
          }
        }
        this.giftcard.loading = false;
      }
    }
  }
};
</script>